import { render, staticRenderFns } from "./ExistSocial.vue?vue&type=template&id=881722ba&"
import script from "./ExistSocial.vue?vue&type=script&lang=js&"
export * from "./ExistSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports